import React from 'react';

export interface GlassTab {
  id: string;
  label: string;
  icon?: React.ReactNode;
}

export interface GlassTabsProps {
  tabs: GlassTab[];
  activeTab: string;
  onChange: (tabId: string) => void;
  className?: string;
  size?: 'sm' | 'md';
}

export const GlassTabs: React.FC<GlassTabsProps> = ({
  tabs,
  activeTab,
  onChange,
  className = '',
  size = 'md',
}) => {
  const containerStyles: React.CSSProperties = {
    display: 'flex',
    gap: 'var(--space-1)',
    padding: 'var(--space-1)',
    background: 'var(--panel)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid var(--stroke)',
    borderRadius: 'var(--radius-md)',
    width: 'fit-content',
  };

  const getTabStyles = (isActive: boolean): React.CSSProperties => {
    const baseStyles: React.CSSProperties = {
      padding: size === 'sm' ? 'var(--space-1) var(--space-3)' : 'var(--space-2) var(--space-4)',
      fontSize: size === 'sm' ? 'var(--text-sm)' : 'var(--text-base)',
      fontWeight: isActive ? 'var(--font-semibold)' : 'var(--font-medium)',
      color: isActive ? 'var(--text)' : 'var(--text-secondary)',
      background: isActive ? 'var(--panel-strong)' : 'transparent',
      border: 'none',
      borderRadius: 'var(--radius-sm)',
      cursor: 'pointer',
      transition: 'all var(--transition-normal)',
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--space-2)',
      whiteSpace: 'nowrap',
    };

    return baseStyles;
  };

  return (
    <div className={`glass-tabs ${className}`} style={containerStyles}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          style={getTabStyles(tab.id === activeTab)}
          onClick={() => onChange(tab.id)}
          onMouseEnter={(e) => {
            if (tab.id !== activeTab) {
              e.currentTarget.style.color = 'var(--text)';
              e.currentTarget.style.background = 'var(--panel-hover)';
            }
          }}
          onMouseLeave={(e) => {
            if (tab.id !== activeTab) {
              e.currentTarget.style.color = 'var(--text-secondary)';
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          {tab.icon && <span>{tab.icon}</span>}
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default GlassTabs;
